import { Button, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SolarIcon from 'components/icons/SolarIcon';
import CopyTextWrapper from 'components/others/CopyTextWrapper';
import { ClientNameItem } from 'modules/client';
import { UserNameItem } from 'modules/user';
import EmailEntryActions from '../EmailEntryActions';
import type { EmailPickerRow } from '../model';
import { useEmailsDirectory } from '../context/EmailsDirProvider';

const EmailsTableRow = ({ row, others }: { row: EmailPickerRow; others: boolean }) => {
    const { t } = useTranslation('EmailsDir');
    const { selected, toggle, chooseClient, userId, busy } = useEmailsDirectory();
    const entry = row.entry;
    const own = entry?.ownerId === userId;
    return (
        <tr>
            <td className="check"><Form.Check aria-label={`${t('choose')}: ${row.name}, ${row.email}`} checked={Boolean(selected[row.key])} onChange={() => toggle(row)} disabled={busy} /></td>
            <td className="name">{others ? (
                <div className="d-flex align-items-center gap-1">
                    <h6 className="mb-0 min-w-0 text-truncate cursor-pointer" title={row.name} onClick={() => chooseClient(row)}>{row.name}</h6>
                    {entry?.isPublic && <OverlayTrigger placement="top" overlay={<Tooltip>{t('public')}</Tooltip>}>
                        <span className="text-muted d-inline-flex flex-shrink-0" tabIndex={0} aria-label={t('public')}><SolarIcon name="people" /></span>
                    </OverlayTrigger>}
                </div>
            ) : (
                <ClientNameItem truncate client={{ ID: row.clientId, clientName: row.name, clientPhone: row.clientPhone }} onClick={busy ? undefined : () => chooseClient(row)} />
            )}</td>
            <td className="email">
                <CopyTextWrapper value={row.email}>
                    <Button type="button" variant="link" className="d-block w-100 p-0 text-truncate text-start text-body text-decoration-none fw-normal" title={row.email} disabled={busy} aria-pressed={Boolean(selected[row.key])} onClick={() => toggle(row)}>
                        {row.email}
                    </Button>
                </CopyTextWrapper>
            </td>
            {others && <td className="username"><UserNameItem smallMode user={{ ID: entry?.ownerId, userName: entry?.authorName || '—', userPicture: entry?.authorPicture }} /></td>}
            {others && <td className="action text-end">{entry && own && <EmailEntryActions entry={entry} />}</td>}
        </tr>
    );
};

export default EmailsTableRow;
